import React, { Component } from "react";
import Plot from "./../../../../utils/customPlotly";
import moment from "moment";
import {
  plotlyMarkerTypes,
  legendPosition,
  chartParams,
} from "../../../../utils/constants";
import NoKPIDataInDateRange from "../../../../assets/no-kpidata-range.png";
import ChartAverageTable from "../../ViewChart/ChartAverageTable";

class DrillDownKpiChart extends Component {
  constructor(props) {
    super(props);
    // state = {
    //   exportingAsPng:false
    // }
  }

  handlePlotContainerClick = () => {
    // console.log(this.props)
    // this.props.reloadChart(this.props.id);
  };

  // exportChartToPng = ()=>{

  //   this.props.onExportAsPng()
  // }

  render() {
    const {
      kpiData,
      benchmarkData,
      selectedOffice,
      isNodeClicked,
    } = this.props;
    console.log("props----", this.props);
    // let{exportingAsPng}=this.state
    let plotlyData = kpiData;
    console.log(this.props);
    let min = 0;
    let max = 1.01;

    let yRange = [-0.05, max];

    if (kpiData && kpiData.length > 0) {
      kpiData.map((kpi) => kpi.y.map((val) => (val > max ? (max = val) : max)));

      if (max == 1.01) {
        yRange = [min, max + 0.1];
      }
    }
    console.log("max value: ", max);
    let tickvalsString = null;
    if (plotlyData.length === 1) {
      if (plotlyData[0].x.length === 1) {
        tickvalsString = [plotlyData[0].x[0]];
      }
    } else {
      let tickvalsDates = 0;
      // console.log(plotlyData);
      let tickvalsList = plotlyData.map((data) => {
        let xvalues = data.x;
        return xvalues;
      });

      let filteredTickvalsList = tickvalsList.filter(
        (tickValue) => tickValue.length === 1
      );

      if (
        tickvalsString == null &&
        tickvalsList.length > 0 &&
        filteredTickvalsList.length > 0
      ) {
        let firstTickVal = filteredTickvalsList[0][0];
        let filterTickVal = filteredTickvalsList.filter((tickVal) =>
          moment(tickVal[0]).isSame(firstTickVal, "month")
        );

        if (filterTickVal.length === filteredTickvalsList.length) {
          tickvalsString = [firstTickVal];
        }
      }
    }
    if (benchmarkData && benchmarkData.x && benchmarkData.x.length > 0) {
      plotlyData = plotlyData.concat(benchmarkData);
    }
    let hasNoData = true;
    plotlyData.forEach((kpi) => {
      if (kpi.x.length > 0 || kpi.y.length > 0) {
        hasNoData = false;
      }
    });

    // console.log("isNodeClicked", isNodeClicked);
    console.log("plotlyData", plotlyData);

    let plotlyDataModified = [];
    if (!isNodeClicked) {
      plotlyDataModified = plotlyData.map((e) => {
        e.name = e.description;
        return e;
      });
    } else {
      plotlyDataModified = plotlyData;
    }

    let chart = {
      kpiData,
      plotlyDTick: kpiData.dtickFormat,
      xMaxDate: kpiData.xMaxDate,
      xMinDate: kpiData.xMinDate,
      yRange,
      name: selectedOffice,
    };

    return (
      <div>
        {!hasNoData ? (
          <div
            style={{
              marginTop: "20px",
              marginBottom: "14px",
              paddingLeft: "8px",
              paddingRight: "8px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div className="drill-down-kpi-title">
                Office : {selectedOffice}
              </div>
              {/* <div style={{color:'#5099DE',cursor:'pointer', 
                          display: exportingAsPng? 'none':'block'
                  }} 
              onClick={()=>this.exportChartToPng()} >
              <i className="flaticon-export drill-down-kpi"></i>
              <span style={{marginLeft:'10px',lineHeight:'22px'}}>
                Export as .png 
              </span>
            </div> */}
            </div>
            <div
              className="kpiCharts"
              onMouseOver={this.handlePlotContainerClick}
            >
              <Plot
                data={plotlyDataModified}
                layout={{
                  showlegend: true,
                  autosize: true,
                  uirevision: true,
                  legend: chartParams(chart, "legend"),
                  paper_bgcolor: "white",
                  plot_bgcolor: "#e5ecf694",
                  margin: chartParams(chart, "margin"),
                  xaxis: chartParams(chart, "xaxis"),
                  yaxis: chartParams(chart, "yaxis"),
                  hovermode: "closest",
                }}
                // useResizeHandler={true}
                scrollZoom={true}
                config={chartParams(chart, "config")}
                // config={{displayModeBar:false}}
                // config={{
                //   // displayModeBar:true,
                //   scrollZoom:true,
                //   // editable:isSafari?false:true,
                //   modeBarButtonsToAdd:['drawline',
                //                             'drawopenpath',
                //                             'drawclosedpath',
                //                             'drawcircle',
                //                             'drawrect',
                //                             'eraseshape',
                //                            ],
                //   displaylogo: false,
                //   // staticPlot:(plotlyData && plotlyData.length>0)?false:true,
                //   responsive: true,
                //   toImageButtonOptions: {
                //     format: 'png', // one of png, svg, jpeg, webp
                //     // moment(d.createdDate).format('MM/DD/YYYY')
                //     filename: `${selectedOffice} - ${moment(new Date()).format('MM-D-YYYY')}`,
                //     height: 600,
                //     width: null,
                //     scale: 1 // Multiply title/legend/axis/canvas sizes by this factor
                //   }
                // }}
                className="kpiCharts"
                style={{ width: "100%" }}
              />

              <div className="ml-5 mr-4 pb-4">
                <ChartAverageTable
                  chartSelector={"_uuid" + this.props.chart._id}
                  kpiForPlotly={this.props.chart.kpiData}
                  yAxisFormat={this.props.chart.yAxisFormat}
                  chart={this.props.chart}
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="text-center no-data-available-desc mt30 mb30">
            <div>
              The KPI you selected is not available for this office. Please
              select another office, or contact your Admin to upload the
              necessary data for this office.
            </div>
            <img
              className="mt20"
              style={{ width: "210px" }}
              src={NoKPIDataInDateRange}
            />
          </div>
        )}
      </div>
    );
  }
}

export default DrillDownKpiChart;
